import TinyColor from 'tinycolor2'

/**
 * Automatically create colour variations from a base colour.
 */
export class ColourVariation {
  private startColor: TinyColor.Instance

  constructor(inputColor: string) {
    this.startColor = new TinyColor(inputColor)
  }

  get gradientEnd() {
    return this.startColor.toHexString()
  }

  get gradientStart() {
    return this.startColor
      .clone()
      .brighten(20)
      .saturate(20)
      .toHexString()
  }

  get transparentGradientStart() {
    return this.startColor
      .clone()
      .brighten(30)
      .setAlpha(0)
      .toRgbString()
  }
}
